import { Col, Container, Row, Button, Spinner } from 'react-bootstrap';
import Link from 'next/link';
import { FaEnvelope, FaUserTie } from 'react-icons/fa';
import { useServicesPage } from '@/hooks/useServicesPage';

const ActionBox = ({ sectionData: propSectionData }) => {
  const { section: fetchedSection, loading } = useServicesPage('action_box');
  const section = propSectionData || fetchedSection;

  // Fallback to default content if section not found or inactive
  const title = section?.title || 'Ready to plan your next season or group?';
  const introText = section?.intro_text || 'Tell us about your allocations, groups or custom brief and we\'ll prepare a proposal that fits your dates, budget and expectations.';
  const ctaContent = section?.content || {};
  const primaryText = ctaContent.cta_primary_text || 'Schedule a call';
  const primaryLink = ctaContent.cta_primary_link || '/contact';
  const primaryIcon = ctaContent.cta_primary_icon || 'FaUserTie';
  const secondaryText = ctaContent.cta_secondary_text || 'Send a request';
  const secondaryLink = ctaContent.cta_secondary_link || '/contact';
  const secondaryIcon = ctaContent.cta_secondary_icon || 'FaEnvelope';

  const PrimaryIcon = primaryIcon === 'FaUserTie' ? FaUserTie : FaEnvelope;
  const SecondaryIcon = secondaryIcon === 'FaEnvelope' ? FaEnvelope : FaUserTie;

  const bgColor = section?.background_color || 'primary';
  const bgEffect = section?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';
  // Apply gradient effect if selected
  if (bgColor === 'primary' && bgEffect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';

  if (loading && !propSectionData) {
    return (
      <section className={`pt-0 pt-md-5 mb-4 ${bgClass} services-section action-box-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`}>
        {hasDotsEffect && (
          <>
            <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
            <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
          </>
        )}
        <Container className={hasDotsEffect ? 'position-relative' : ''}>
          <div className="text-center py-3">
            <Spinner animation="border" variant="primary" size="sm" />
          </div>
        </Container>
      </section>
    );
  }

  return (
    <section className={`pt-0 pt-md-5 mb-4 ${bgClass} services-section action-box-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container className={hasDotsEffect ? 'position-relative' : ''}>
        <div className="bg-gradient bg-primary bg-opacity-10 rounded-3 position-relative p-3 p-sm-4">
          <Row>
            <Col md={10} lg={8} className="mx-auto text-center py-4">
              <h2 className="sec-title mb-3">{title}</h2>
              <p className="intro-text mb-4" dangerouslySetInnerHTML={{ __html: introText }} />
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                <Button as={Link} href={primaryLink} variant="primary" size="lg" className="mb-0">
                  <PrimaryIcon className="me-2" />
                  {primaryText}
                </Button>
                <Button as={Link} href={secondaryLink} variant="outline-primary" size="lg" className="mb-0">
                  <SecondaryIcon className="me-2" />
                  {secondaryText}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default ActionBox;

